import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {getAppInfo} from "../../../../actions/sideBar.actions";
import {getSideBar} from "../../../../selectors";
import isEmpty from "../../../../utils/helpers";
import {compact} from 'lodash'

class OperationModuleMenu extends Component {

    state = {
        activeSubMenuItem: '',
    }

    changeSubMenuItem = (subMenuItem) => {
        if (this.state.activeSubMenuItem === subMenuItem) {
            this.setState({activeSubMenuItem: ''});
        } else {
            this.setState({activeSubMenuItem: subMenuItem});
        }
    }

    hasPermission = permission => !isEmpty(this.props.permissions) && this.props.permissions.includes(permission);

    hasMenuPermission = permission => !isEmpty(this.props.userPermissionMenu) && this.props.userPermissionMenu.permissions.includes(permission);

    renderAppointmentsMenu = () => {

        if (!this.hasPermission("ADMN_USER_DETAIL")) {
            return null;
        }

        const { activeMenu, appInfo, changeActiveMenu, permissions } = this.props;
        const { activeSubMenuItem } = this.state;

        return (
            <li key={"Appointments"} className={activeMenu === 'Appointments' ? 'sidebar-dropdown active' : 'sidebar-dropdown'}>
                <a onClick={() => changeActiveMenu('Appointments')}>
                    <i className="fas fa-clock"/>
                    <span>Appointments</span>
                </a>

                <div className="sidebar-submenu"
                     style={activeMenu === 'Appointments' && !isEmpty(appInfo) ? {display: 'block'} : {display: 'none'}}>
                    <ul>
                        <li className="sidebar-nav-link">
                            <Link to={{ pathname: '/capacity-configuration' }}>Capacity</Link>
                        </li>
                    </ul>
                </div>
            </li>
        )
    }

    renderBillingMenu = () => {

        if (!this.hasMenuPermission("SHOW_BILLING_JOBS")) {
            return null;
        }

        const { activeMenu, appInfo, changeActiveMenu } = this.props;
        const { activeSubMenuItem } = this.state;

        return (
            <li key={"BillingJobs"} className={activeMenu === 'Billing' ? 'sidebar-dropdown active' : 'sidebar-dropdown'}>
                <a onClick={() => changeActiveMenu('Billing')}>
                    <i className="fa fa-file-invoice-dollar"/>
                    <span>Billing</span>
                </a>

                <div className="sidebar-submenu"
                     style={activeMenu === 'Billing' && !isEmpty(appInfo) ? {display: 'block'} : {display: 'none'}}>
                    <ul>
                        <li className="sidebar-nav-link">
                            <Link to={{ pathname: '/billing-jobs' }}>Billing Jobs</Link>
                        </li>
                    </ul>
                </div>
            </li>
        )
    }

    renderAutoPayMenu = () => {

        if (!this.hasPermission("ADMN_VIEW_AUTOPAY_JOBS")) {
            return null;
        }

        const { activeMenu, appInfo, changeActiveMenu } = this.props;

        return (
            <li key={"AutoPayJobs"} className={activeMenu === 'AutoPay' ? 'sidebar-dropdown active' : 'sidebar-dropdown'}>
                <a onClick={() => changeActiveMenu('AutoPay')}>
                    <i className="fa fa-file-invoice-dollar"/>
                    <span>AutoPay</span>
                </a>

                <div className="sidebar-submenu"
                     style={activeMenu === 'AutoPay' && !isEmpty(appInfo) ? {display: 'block'} : {display: 'none'}}>
                    <ul>
                        <li className="sidebar-nav-link">
                            <Link to={{ pathname: '/autopay-jobs' }}>AutoPay Jobs</Link>
                        </li>
                    </ul>
                </div>
            </li>
        )
    }

    renderProvisioningMenu = () => {

        if (!this.hasMenuPermission("SHOW_MANUAL_PROVISIONING")) {
            return null;
        }

        const { activeMenu, appInfo, changeActiveMenu } = this.props;
        const { activeSubMenuItem } = this.state;

        return (
            <li key={"Provisioning"} className={activeMenu === 'Provisioning' ? 'sidebar-dropdown active' : 'sidebar-dropdown'}>
                <a onClick={() => changeActiveMenu('Provisioning')}>
                    <i className="fas fa-stream"/>
                    <span>Provisioning</span>
                </a>

                <div className="sidebar-submenu"
                     style={activeMenu === 'Provisioning' && !isEmpty(appInfo) ? {display: 'block'} : {display: 'none'}}>
                    <ul>
                        <li className="sidebar-nav-link">
                            <Link to={{ pathname: '/provisioning-tool' }}>Provisioning Tool</Link>
                        </li>
                        <li className="sidebar-nav-link">
                            <Link to={{ pathname: '/provisioning-queue' }}>Provisioning Queue</Link>
                        </li>
                    </ul>
                </div>
            </li>
        )
    }

    renderSubMenuItems = () => {
        const subMenuItems = compact([
            this.renderAppointmentsMenu(),
            this.renderBillingMenu(),
            this.renderAutoPayMenu(),
            this.renderProvisioningMenu(),
        ]);

        return subMenuItems;
    }

    render() {

        const {activeMenu} = this.props;

        const subMenuItems = this.renderSubMenuItems();

        if (isEmpty(subMenuItems)) {
            return null;
        }

        return (
            <ul>
                <li className="header-menu">
                    <span>Operation</span>
                </li>
                {subMenuItems}
            </ul>
        );
    }
}

OperationModuleMenu.propTypes = {
    activeMenu: PropTypes.string.isRequired,
    changeActiveMenu: PropTypes.func.isRequired,
    permissions: PropTypes.array.isRequired,
};


const mapStateToProps = (state) => {

    const appInfo = getSideBar(state).appInfo;

    return {
        appInfo,
    };
};

const mapDispatchToProps = {
    getAppInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(OperationModuleMenu);
